import React, {useState, useEffect} from 'react';
import {
    Tabs, TabList, TabPanels, Tab, TabPanel, Image, Box, Text, Flex, SimpleGrid, useDisclosure,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Button
} from '@chakra-ui/react'
import { StyleSheet, css } from 'aphrodite';
// import { seminarDetails } from './SeminarDetails';
import { useSelector, useDispatch } from 'react-redux'
import { fetchData } from 'actions/actions';

function TEMSeminarFr() {

    const { isOpen, onOpen, onClose } = useDisclosure()
    const dispatch = useDispatch();
    const [selectedSeminar, setSelectedSeminar] = useState(null);
    const data = useSelector(state=>state.data.data.seminarFr)

    const isMobile = useSelector(state=> state.windowSize.isMobile);

    useEffect(() => {
        // Dispatch the fetchData action when the component mounts
        dispatch(fetchData());
      }, [dispatch]); 

    console.log('TEMFr', data)

    const handleSeminarClick = (seminarTitle) => {
        const foundSeminar = data?.find(seminar => seminar.titleFr === seminarTitle);
        if (foundSeminar) {
            console.log("selectedSeminar updated:", foundSeminar);
          setSelectedSeminar(foundSeminar);
          onOpen();
        }
    };

    const parseFrenchDate = (dateStr) => {
        if (!dateStr) return null;

        const months = {
            janvier: 0,
            février: 1, fevrier: 1,
            mars: 2,
            avril: 3,
            mai: 4,
            juin: 5,
            juillet: 6,
            août: 7, aout: 7,
            septembre: 8,
            octobre: 9,
            novembre: 10,
            décembre: 11, decembre: 11,
        };

        // Normalize: lowercase, remove commas, collapse spaces
        const s = String(dateStr)
            .toLowerCase()
            .replace(/,/g, " ")
            .replace(/\s+/g, " ")
            .trim();

        // Accept: "16 janvier 2026" (optionally followed by time text)
        // We only need day + month + (optional) year
        const m = s.match(/^(\d{1,2})\s+([a-zéûîôàç]+)(?:\s+(\d{4}))?/i);
        if (!m) return null;

        const day = parseInt(m[1], 10);
        const monthName = m[2];
        const month = months[monthName];
        const year = m[3] ? parseInt(m[3], 10) : new Date().getFullYear(); // if missing, assume current year

        if (!day || month === undefined || !year) return null;

        // Create date in local timezone
        const d = new Date(year, month, day);
        return Number.isNaN(d.getTime()) ? null : d;
    };

    const isFutureDateFR = (dateStr) => {
        const seminarDate = parseFrenchDate(dateStr);
        if (!seminarDate) return false;

        const today = new Date();
        seminarDate.setHours(0, 0, 0, 0);
        today.setHours(0, 0, 0, 0);

        return seminarDate >= today; // use >= if you want "today" to count as upcoming
    };


  return (
    <>
    {data ? (
        <Box maxW="95%" mx="auto" pt={8} pb={12}>
            {/* Grid */}
            <SimpleGrid columns={isMobile ? 1 : 3} spacing={10} justifyContent="center">
            {data
                ?.filter((seminar) => seminar.type === "TEM")
                .slice()        // copy (do NOT mutate original)
                .reverse()      // newest-added first
                .map((content, index) => (
                <Box
                    className={css(styles.card)}
                    onClick={() => handleSeminarClick(content.titleFr)}
                    key={index}
                    cursor="pointer"
                >
                    <Text className={css(styles.heading)} fontSize={20} color={isFutureDateFR(content.date) ? "red.500" : "black.600"}>
                    {content.titleFr}
                    </Text>

                    {/* Date (red if future) + (upcoming) */}
                    <Text
                    className={css(styles.subtitle)}
                    color={isFutureDateFR(content.dateFr) ? "red.500" : "gray.600"}
                    >
                    {content.dateFr}
                    {isFutureDateFR(content.dateFr) && (
                        <Text as="span" fontWeight="bold" ml={2}>
                        (À venir)
                        </Text>
                    )}
                    </Text>

                    <Flex justifyContent="center">
                    <hr style={{ width: "50%", borderWidth: "2px" }} />
                    </Flex>

                    <Text className={css(styles.subtitle)}>
                    {content.address}
                    </Text>

                    {/* New last line */}
                    <Text
                    fontSize="sm"
                    mt={3}
                    textAlign="center"
                    color="blue.500"
                    fontStyle="italic"
                    >
                    Click for more information
                    </Text>
                </Box>
                ))}
            </SimpleGrid>

            {/* Empty state */}
            {data?.filter((seminar) => seminar.type === "TEM").length === 0 && (
            <Text textAlign="center" width="100%" fontWeight="bold" mt={8}>
                Exciting Seminars Coming Soon, Stay Tuned!
            </Text>
            )}
        </Box>
        ) : (
        <Flex minH="50vh" align="center" justify="center">
            Loading...
        </Flex>
        )}

    {/* Modal (unchanged) */}
    <Modal isOpen={isOpen} onClose={onClose} isCentered size={"3xl"} allowPinchZoom>
        <ModalOverlay />
        <ModalContent>
            {selectedSeminar && (
            <>
                <ModalHeader>About our host</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                <Image
                    src={selectedSeminar.imageLink}
                    alt={selectedSeminar.title}
                    width="100%"
                />
                </ModalBody>

                <ModalFooter>
                <Button colorScheme="red" mr={3} onClick={onClose}>
                    Close
                </Button>
                </ModalFooter>
            </>
            )}
        </ModalContent>
    </Modal>
    </>
  )
};

const styles = StyleSheet.create({
    tabParent: {
        fontSize: 20,
        fontWeight: 'bold',
        color: '#DC242C'
    },
    heading: {
        fontWeight: 'bold',
        fontSize: '18',
        textAlign: 'center',
        marginTop: 5
    },
    subtitle: {
        fontSize: '20',
        textAlign: 'center',
        marginTop: 5,
        fontWeight: 'bold'
    },
    card: {
        borderWidth: '1px',
        borderRadius: '5px',
        borderColor: 'gray',
        justifyContent: 'center',
        textAlign: 'center',
        ':hover': {
          cursor: 'pointer'  
        },
        position: 'relative'
    },
    dateCircle: {
        position: 'absolute',
        bottom: 75,
        left: '50%', // Adjust as needed for positioning
        transform: 'translateX(-50%)',
        width: '10%',
        height: '10%',
        borderRadius: '50%',
        backgroundColor: 'black', // Change color as needed
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1, // Ensure the circle is above the image
      },
      dateText: {
        color: 'white',
        fontSize: '16',
        // fontWeight: 'bold',
        // Adjust text styles as needed
      },
})

export default TEMSeminarFr